import { apiClient } from './api'
import type { ServiceName, SubscriptionStatus } from './subscription'

export interface DashboardSubscriptionSummary {
  service_name: ServiceName
  status: SubscriptionStatus
  plan_tier: string
  current_period_end: string
  cancel_at_period_end: boolean
}

export interface DashboardUsageSummary {
  service_name: ServiceName
  metric_name: string
  count: number
  limit?: number
  percentage_used?: number
  period_end: string
}

export interface DashboardOverviewResponse {
  organization_id: string
  organization_name: string
  member_count: number
  active_subscriptions: number
  total_subscriptions: number
  subscriptions: DashboardSubscriptionSummary[]
  usage_summary: DashboardUsageSummary[]
  recent_activity_count?: number
}

export interface DashboardSubscriptionsResponse {
  organization_id: string
  subscriptions: DashboardSubscriptionSummary[]
  total_active: number
  total_trial: number
  total_expired: number
  total_cancelled: number
}

export interface DashboardUsageResponse {
  organization_id: string
  usage: DashboardUsageSummary[]
  total_usage: Record<string, number>
  warnings: string[]
}

export const dashboardService = {
  // Get dashboard overview
  getOverview: async (
    organizationId?: string
  ): Promise<DashboardOverviewResponse> => {
    const response = await apiClient.get<DashboardOverviewResponse>(
      '/dashboard/overview',
      {
        params: organizationId ? { organization_id: organizationId } : undefined,
      }
    )
    return response.data
  },

  // Get subscription status
  getSubscriptions: async (
    organizationId?: string
  ): Promise<DashboardSubscriptionsResponse> => {
    const response = await apiClient.get<DashboardSubscriptionsResponse>(
      '/dashboard/subscriptions',
      {
        params: organizationId ? { organization_id: organizationId } : undefined,
      }
    )
    return response.data
  },

  // Get usage summary
  getUsage: async (
    organizationId?: string
  ): Promise<DashboardUsageResponse> => {
    const response = await apiClient.get<DashboardUsageResponse>(
      '/dashboard/usage',
      {
        params: organizationId ? { organization_id: organizationId } : undefined,
      }
    )
    return response.data
  },
}

